"use strict";

exports.__esModule = true;
exports.EDITOR_TYPE = exports.CheckboxEditor = void 0;
var _checkboxEditor = require("./checkboxEditor");
exports.EDITOR_TYPE = _checkboxEditor.EDITOR_TYPE;
exports.CheckboxEditor = _checkboxEditor.CheckboxEditor;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/checkboxEditor/index.js
// module id = 443
// module chunks = 0